// Utility for mobile detection
export default function isMobileScreen() {
  return typeof window !== "undefined" && window.innerWidth <= 800;
}
